import * as React from "react";
import {connect} from "react-redux";
import {CallbackComponent} from "redux-oidc";
import {copyOidcUserToCurrentUser, userManager} from "./utils/userManager";
import {RouteComponentProps} from 'react-router';
import * as Oidc from 'oidc-client';
import * as Model from '../user/model';
import {Redirect} from "react-router-dom";
import axios from "axios";
import {actions} from "../user/actions";
import {FormattedMessage, InjectedIntlProps} from "react-intl";
import {
  localRepository,
  PREVIEW_BACKGROUND_LAYERNAME,
  PREVIEW_BACKGROUND_SUBDOMAINS,
  PREVIEW_BACKGROUND_TYPE,
  PREVIEW_BACKGROUND_URL
} from "../common/LocalRepository";
import {oidcUtils} from "./utils/OidcUtils";
import {WithApi, WithApiProperties} from "../common/util/WithApi";
import {oidcProviderInfo} from "./startOidcProvider";

interface CallbackPageProps {
  dispatch: (action) => any;
}

export class CallbackPageComponent extends React.Component<CallbackPageProps & RouteComponentProps<any> & WithApiProperties & InjectedIntlProps> {
  // define a success callback which receives the signed-in user & handles redirection
  successCallback = (user: Oidc.User) => {
    try {
      if (user?.access_token) {
        const clientId = oidcProviderInfo?.clientId;
        if (!oidcUtils.isOidcAdminRole(clientId)) {
          oidcUtils.logoutOidcProvider().then(() => {
                this.props.dispatch(actions.setUser(null));
            oidcUtils.replaceOidcUrlWithLoginUrl();
              });
          throw new Error("User does not have role for Studio login.");
        } else {
          // the user object gets the browser's URL before
          // redirection was triggered passed into its state
          // when triggerAuthFlow is set to `true`
          const urlBeforeRedirection = user.state.urlBeforeRedirection;
          axios.interceptors.request.use(c => {
            c.headers.Authorization = "Bearer " + oidcUtils.getOidcTokenValue();
            return c;
          });
          const currentUser: Model.User = copyOidcUserToCurrentUser(user);
          this.props.dispatch(actions.setUser(currentUser));
          this.loadConfig(urlBeforeRedirection);
        }
      }
    } catch (error) {
      throw new Error("Callback was successful;however, error happened while processing result : " +  error);
    }
  }

  configLoaded = (redirectTo) => {
    const {history} = this.props;
    history.push(redirectTo);
  }

  loadConfig = (redirectTo) => {
    this.props.api.getStudioSettings()
        .then((studioSettings) => {
          const {
            previewBackgroundType,
            previewBackgroundUrl,
            previewBackgroundLayername,
            previewBackgroundSubdomains
          } = studioSettings.data.values;
          localRepository.setParameter(PREVIEW_BACKGROUND_TYPE, previewBackgroundType);
          localRepository.setParameter(PREVIEW_BACKGROUND_URL, previewBackgroundUrl);
          localRepository.setParameter(PREVIEW_BACKGROUND_SUBDOMAINS, previewBackgroundSubdomains);
          localRepository.setParameter(PREVIEW_BACKGROUND_LAYERNAME, previewBackgroundLayername);
        })
        .catch((error) => {
          this.setState({submitting: false, error});
        })
        .finally(() => {
          this.configLoaded(redirectTo);
        });
  }

  errorCallback = (error: Error) => {
    const redirectUrl = "/";
    this.props.history.push(redirectUrl);
    throw new Error("Callback failed :" + error);
  }

  render() {
    return (
        <CallbackComponent
            userManager={userManager}
            successCallback={this.successCallback}
            errorCallback={this.errorCallback}>
          <Redirect
              to={{
                pathname: "/",
              }}><FormattedMessage id="studio.oidc.callback.redirect" defaultMessage="Redirecting..."/></Redirect>
        </CallbackComponent>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  };
}
export const CallbackPage = connect(null, mapDispatchToProps)(WithApi(CallbackPageComponent));
